export default __webpack_public_path__ + "static/media/04A.020.640d0e12.png";